import React from 'react'
import st from './ClientInformation.module.scss'
import Checkbox from 'components/ContentBox/Global/Checkbox/Checkbox'
import { formatClientDate } from '../utils'
import useLocalization from 'hooks/useLocalization'

const ClientInformation = ({
  card,
  duplicate,
  checkedStates,
  handleCheckboxChange,
  handleSelectAll,
}) => {
  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      name: 'Name',
      level: 'Level',
      transaction: 'Transaction',
      date_of_creation: 'Date of creation',
      phone_number: 'Phone number',
      responsible: 'Responsible',
      budget: 'Budget',
      city: 'City',
      branch: 'Branch',
      program: 'Program',
      deal_status: 'Deal status',
      choose_all: 'Choose all',
      client_profile: 'Client Profile',
    },
  })

  return (
    <div className={st.container}>
      <div className={st.containerInf}>
        <div className={st.containerHeader}>
          <div className={st.chooseAll} onClick={handleSelectAll}>
            {translate?.choose_all}
          </div>
          <div className={st.clientPrf}>{translate?.client_profile}</div>
        </div>
        <div className={st.information}>
          <div className={st.checkboxInp}>
            <Checkbox
              checked={checkedStates.name === card.id}
              onChange={() =>
                handleCheckboxChange('name', card.id, duplicate.name)
              }
            />
          </div>
          <div className={st.name}>{translate?.name}:</div>
          <div className={st.data}>{duplicate.name}</div>
        </div>
        <div className={st.information}>
          <div className={st.checkboxInp}>
            <Checkbox
              checked={checkedStates.deal_name === card.id}
              onChange={() =>
                handleCheckboxChange('deal_name', card.id, card.deal_name)
              }
            />
          </div>
          <div className={st.name}>{translate?.transaction}:</div>
          <div className={st.data}>#{card.deal_name}</div>
        </div>
        <div className={st.information}>
          <div className={st.checkboxInp}>
            <Checkbox
              checked={checkedStates.created_at === card.id}
              onChange={() =>
                handleCheckboxChange('created_at', card.id, card.created_at)
              }
            />
          </div>
          <div className={st.name}>{translate?.date_of_creation}:</div>
          <div className={st.data}>{formatClientDate(card.created_at)}</div>
        </div>
        <div className={st.information}>
          <div className={st.checkboxInp}>
            <Checkbox
              checked={checkedStates.phone === card.id}
              onChange={() =>
                handleCheckboxChange('phone', card.id, duplicate.phone)
              }
            />
          </div>
          <div className={st.name}>{translate?.phone_number}:</div>
          <div className={st.data}>{duplicate.phone}</div>
        </div>
      </div>
      <div className={st.responsible}>
        <div className={st.block}>
          <div className={st.blockInf}>
            <div className={`${st.checkboxInp} ${st.widthInf}`}>
              <Checkbox
                checked={checkedStates.manager === card.id}
                onChange={() =>
                  handleCheckboxChange(
                    'manager',
                    card.id,
                    card?.manager?.full_name,
                  )
                }
              />
              <div className={st.styleRespons}>{translate?.responsible}</div>
            </div>
            <div className={st.styleRespons}>{card?.manager?.full_name}</div>
          </div>
          <div className={st.blockInf}>
            <div className={`${st.checkboxInp} ${st.widthInf}`}>
              <Checkbox
                checked={checkedStates.budget === card.id}
                onChange={() =>
                  handleCheckboxChange('budget', card.id, card.budget)
                }
              />
              <div className={st.styleRespons}>{translate?.budget}</div>
            </div>
            <div className={st.styleRespons}>{card.budget}</div>
          </div>
          <div className={st.blockInf}>
            <div className={`${st.checkboxInp} ${st.widthInf}`}>
              <Checkbox
                checked={checkedStates.city === card.id}
                onChange={() =>
                  handleCheckboxChange('city', card.id, card?.city?.name)
                }
              />
              <div className={st.styleRespons}>{translate?.city}</div>
            </div>
            <div className={st.styleRespons}>{card?.city?.name}</div>
          </div>
          <div className={st.blockInf}>
            <div className={`${st.checkboxInp} ${st.widthInf}`}>
              <Checkbox
                checked={checkedStates.branch === card.id}
                onChange={() =>
                  handleCheckboxChange('branch', card.id, card?.branch?.name)
                }
              />
              <div className={st.styleRespons}>{translate?.branch}</div>
            </div>
            <div className={st.styleRespons}>{card?.branch?.name}</div>
          </div>
          <div className={st.blockInf}>
            <div className={`${st.checkboxInp} ${st.widthInf}`}>
              <Checkbox
                checked={checkedStates.program === card.id}
                onChange={() =>
                  handleCheckboxChange('program', card.id, card?.program?.name)
                }
              />
              <div className={st.styleRespons}>{translate?.program}</div>
            </div>
            <div className={st.styleRespons}>{card?.program?.name}</div>
          </div>
          <div className={st.blockInf}>
            <div className={`${st.checkboxInp} ${st.widthInf}`}>
              <Checkbox
                checked={checkedStates.level === card.id}
                onChange={() =>
                  handleCheckboxChange('level', card.id, card?.level?.name)
                }
              />
              <div className={st.styleRespons}>{translate?.level}</div>
            </div>
            <div className={st.styleRespons}>{card?.level?.name}</div>
          </div>
          <div className={st.blockInf}>
            <div className={`${st.checkboxInp} ${st.widthInf}`}>
              <Checkbox
                checked={checkedStates.status_deal === card.id}
                onChange={() =>
                  handleCheckboxChange(
                    'status_deal',
                    card.id,
                    card?.status_deal?.name,
                  )
                }
              />
              <div className={st.styleRespons}>{translate?.deal_status}</div>
            </div>
            <div className={st.styleRespons}>{card?.status_deal?.name}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientInformation
